import { useEffect, useState } from 'react';
import { IoEnterOutline } from 'react-icons/io5';
import { Button, ButtonToolbar, Stack } from 'rsuite';
import {
  FirmwareDownload,
  Reboot,
  getSafeUrl,
  useAppSelector,
  useLazyGetInstanceAccessUrlQuery,
  useLazyGetVmStatusQuery,
  useQuery
} from '@monorepo/shared';
import { selectInstances } from '@monorepo/shared/store/instanceSlice';
import { selectCurrentGroup } from '@monorepo/shared/store/groupSlice';
import { MdOutlineRestartAlt } from 'react-icons/md';
import { useTranslation } from 'react-i18next';
import { selectInstancesExtraInfo } from '@monorepo/shared/store/instanceExtraSlice';
import { InstanceAction } from '../../config/const';
interface IProps {
  rowData: Record<string, any>;
  server: string;
  actionConst: Record<string, any>;
}
export const InstanceActions = ({ rowData, server, actionConst }: IProps) => {
  const { t } = useTranslation();
  const instances = useAppSelector(selectInstances);
  const instancesExtraInfo = useAppSelector(selectInstancesExtraInfo);
  const currentGroup = useAppSelector(selectCurrentGroup);
  const [instance, setInstance] = useState<Record<string, any>>({});
  const [extraInfo, setExtraInfo] = useState<Record<string, any>>({});
  const [isActive, setIsActive] = useState<boolean>(false);
  const [isExpired, setIsExpired] = useState<boolean>(false);
  const [isForceUpgrade, setIsForceUpgrade] = useState<boolean>(false);

  const [showUpgrade, setShowUpgrade] = useState<boolean>(false);
  const [showEnter, setShowEnter] = useState<boolean>(true);
  const [message, setMessage] = useState<string>('');

  const [getInstanceUrl] = useLazyGetInstanceAccessUrlQuery();
  const [getVmStatus] = useLazyGetVmStatusQuery();

  let query = useQuery();
  const debugKey = query.get('debug_key') || undefined;
  const [rebootDrawerOpen, setRebootDrawerOpen] = useState<boolean>(false);

  useEffect(() => {
    const data = instances?.[currentGroup.id]?.[rowData?.account_id];
    const extra = instancesExtraInfo?.[currentGroup.id]?.[rowData?.account_id];
    if (data) {
      setInstance({ ...data });
      setIsExpired(data?.is_expired);
    }
    if (extra?.requestStatus === 'pending') {
      setMessage(`${t('common.expandedRow.actionMessage.fetch')}`);
      setShowEnter(false);
    } else if (extra?.requestStatus === 'fulfilled') {
      setIsActive(!!extra?.is_active);
      setExtraInfo(extra);
    }
  }, [instances, instancesExtraInfo]);

  useEffect(() => {
    if (extraInfo?.requestStatus === 'fulfilled') {
      if (isForceUpgrade) {
        setShowUpgrade(true);
      }
      if (isExpired || isForceUpgrade || !isActive) {
        setShowEnter(false);
        if (isExpired) {
          setMessage(
            `${t('common.expandedRow.actionMessage.expiredInstance')}`
          );
        } else if (isForceUpgrade) {
          setMessage(`${t('common.expandedRow.actionMessage.forceUpgrade')}`);
        } else if (!isActive) {
          setMessage(
            `${t('common.expandedRow.actionMessage.inactiveInstance')}`
          );
        }
      } else {
        setShowEnter(true);
        setMessage('Click to Enter Instance');
      }
    }
  }, [isExpired, isForceUpgrade, isActive, t]);
  return (
    <Stack direction="column" spacing={6}>
      <div
        style={{
          visibility: !showEnter ? 'visible' : 'hidden',
          height: '16px',
          color: 'var(--blue)',
          fontWeight: 'bold'
        }}
      >
        {message}
      </div>
      <ButtonToolbar style={{ justifyContent: 'center' }}>
        <Button
          startIcon={<IoEnterOutline />}
          className="action-btn"
          appearance="primary"
          disabled={!showEnter}
          onClick={async () => {
            const data = await getInstanceUrl({
              account: rowData
            }).unwrap();
            const url = data?.url;
            if (url) {
              window.open(getSafeUrl(url), '_blank');
            }
          }}
        >
          {t('common.expandedRow.enter')}
        </Button>
        <>{showUpgrade && <FirmwareDownload rowData={rowData} />}</>
        {(rowData?.all_assets_access || instance?.is_fullaccess) && (
          <>
            <Button
              startIcon={<MdOutlineRestartAlt />}
              className="action-btn"
              appearance="ghost"
              onClick={() => {
                setRebootDrawerOpen(true);
              }}
            >
              {t('fsa.organization.functionMenu.reboot')}
            </Button>
            <Reboot
              rowData={rowData}
              open={rebootDrawerOpen}
              setOpen={setRebootDrawerOpen}
              rebootAction={InstanceAction?.reboot}
            />
          </>
        )}
      </ButtonToolbar>
    </Stack>
  );
};
